import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface LocationStaffDeleteDialogData {
  staffName: string;
}

@Component({
    selector: 'app-location-staff-delete-dialog',
    templateUrl: './location-staff-delete-dialog.component.html',
    styleUrls: ['./location-staff-delete-dialog.component.css'],
    standalone: false
})
export class LocationStaffDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LocationStaffDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocationStaffDeleteDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
